import React from 'react';
import { observer } from 'mobx-react';
import Styled from 'styled';
import defaultStyles from './split-view.scss';

@Styled(defaultStyles)
@observer
class SplitView extends React.Component {
    static defaultProps = {
        flop: false,
    };

    render() {
        const { mainContent, sideContent, flop, styles } = this.props;
        const classNames = [styles.split];

        if (flop) {
            classNames.push(styles.flop);
        }

        return (
            <div className={classNames.join(' ')}>
                <div className={styles.mainContent}>{mainContent}</div>
                <div className={styles.sideContent}>{sideContent}</div>
            </div>
        );
    }
}

export default SplitView;
